"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLocalizedArtNr = void 0;
const isLocalizedArtNr = (whatever) => {
    return Boolean((whatever === null || whatever === void 0 ? void 0 : whatever['DE']) || (whatever === null || whatever === void 0 ? void 0 : whatever['US']));
};
exports.isLocalizedArtNr = isLocalizedArtNr;
//# sourceMappingURL=LocalizedArtNr.js.map